export function extractHttpErrorMessage(error: unknown, fallback: string): string {
	if (!error || typeof error !== 'object') {
		return fallback;
	}

	const axiosError = error as {
		message?: string;
		response?: {
			data?: unknown;
			status?: number;
			statusText?: string;
		};
	};

	const data = axiosError.response?.data;

	if (typeof data === 'string' && data.trim().length > 0) {
		return data;
	}

	if (data && typeof data === 'object') {
		const record = data as Record<string, unknown>;
		if (typeof record.message === 'string' && record.message.trim().length > 0) {
			return record.message;
		}
		if (typeof record.title === 'string' && record.title.trim().length > 0) {
			return record.title;
		}
		if (typeof record.error === 'string' && record.error.trim().length > 0) {
			return record.error;
		}
		try {
			return JSON.stringify(data);
		} catch {
			return fallback;
		}
	}

	if (axiosError.response?.statusText) {
		const status = axiosError.response.status;
		return status ? `${status} ${axiosError.response.statusText}` : axiosError.response.statusText;
	}

	if (typeof axiosError.message === 'string' && axiosError.message.trim().length > 0) {
		return axiosError.message;
	}

	return fallback;
}
